import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Observable, throwError, race, timer } from "rxjs";
import { filter, mergeMap, catchError, take, map } from "rxjs/operators";
import { CustomErrorHandlerService } from "../api/custom-error-handler.service";

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private errorHandler: CustomErrorHandlerService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // @NOTE: If you have some endpoints that are public
    // and do not need Authorization header, implement logic
    // here to accommodate that and conditionally let public
    // requests pass through based on your requirements

    // Race between getting a token and a timeout of 1 second
    return race(
      this.auth.token$.pipe(
        filter(token => typeof token === "string"),
        take(1)
      ),
      timer(5000).pipe(
        map(() => {
          console.warn('[TokenInterceptor] Token retrieval timed out (>5s). Request will be sent without Auth info.');
          return null as any;
        }),
        take(1)
      )
    ).pipe(
      mergeMap(token => {
        try {
          if (req.url.includes(".s3.")) {
            return next.handle(req);
          }
          let tokenReq;
          if (token) {
            // console.debug('[TokenInterceptor] Attaching token to:', req.url);
            tokenReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            });
          } else {
            console.warn('[TokenInterceptor] No token available for:', req.url);
            tokenReq = req.clone();
          }
          return next.handle(tokenReq);
        } catch (e) {
          console.error("TokenInterceptor: Error processing token", e);
          return next.handle(req);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error("TokenInterceptor: HTTP Error", error);
        return throwError((): HttpErrorResponse => this.errorHandler.tryParseError(error));
      })
    );
  }
}
